import { MISC_PATH } from './miscPath';
import i18n from '../../../locales/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faCommentDots } from '@fortawesome/free-regular-svg-icons';

export const miscBar = {
  subheader: i18n.t('sidemenu.misc.title'),
  items: [
    {
      title: i18n.t('sidemenu.misc.manageUser'),
      path: MISC_PATH.MANAGE_USER,
      icon: <FontAwesomeIcon icon={faUser} style={{ fontSize: '20px' }} />,
    },
    {
      title: i18n.t('sidemenu.misc.deliveryMessage'),
      path: MISC_PATH.DELIVERY_MESSAGE,
      icon: <FontAwesomeIcon icon={faCommentDots} style={{ fontSize: '20px' }} />,
    },
  ],
};

export const miscBarForMaker = {
  subheader: i18n.t('sidemenu.misc.title'),
  items: [
    {
      title: i18n.t('sidemenu.misc.deliveryMessage'),
      path: MISC_PATH.DELIVERY_MESSAGE,
      icon: <FontAwesomeIcon icon={faCommentDots} style={{ fontSize: '20px' }} />,
    },
  ],
};
